import { render, staticRenderFns } from "./TrademarkOpposition.vue?vue&type=template&id=d3c46efe&"
import script from "./TrademarkOpposition.vue?vue&type=script&lang=js&"
export * from "./TrademarkOpposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports